 <template>
    <div class="contest-container">
        <div class="banner" v-if="banner_list.length">
            <div class="swiper-container">
                <swiper :options="swiperOptions" ref="mySwiper" v-if="banner_list.length" @click.native="handleSwiperContainerClick">
                    <!-- Slides -->
                    <swiper-slide v-for="(item,index) in banner_list" :key="index">
                        <!--  @click="onSwiperClick(item)" -->
                        <img :src="item.image" class="swiper-img" :data-url="item.url" />
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                </swiper>
            </div>
        </div>
        <div class="contest-list">
            <div class="title-under-banner">—— 热门大赛 ——</div>
            <div class="contest-item" v-for="(item,index) in list" :key="index" @click="$router.push({name:'ContestDetail',query:{uuid:item.uuid},params:{uuid:item.uuid}})">
                <img :src="item.cover|default_img" />
                <div class="contest-desc">
                    <div class="title">{{item.title}}</div>
                    <div class="time-range">起止时间:{{item.start_time}} - {{item.end_time}}</div>
                    <div class="status">
                        <div class="status-label" :class="[item.status_label]" v-if="item.status == 2">
                            {{item.match_time | countDay}}
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else-if="item.status == 1">
                            {{item.sign_time | countSign}}
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else-if="item.status == 0">
                            即将开始
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else-if="item.status == 3">
                            评审中
                        </div>
                        <div class="status-label" :class="[item.status_label]" v-else>
                             已结束
                        </div>
                        <div class="views">
                            <img src="../../assets/images/icon-view-popup.png" />
                            {{item.view_times || 0}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="page-container">
                <Page :total="total_count" prev-text="上一页" next-text="下一页" @on-change="onPageChange"></Page>
            </div>
        </div>
        <div class="create-contest">
             <!-- <div class="create-contest-main"></div> -->
              <div class="title">衣创社区设计大赛</div>
              <div class="desc">是品牌赛事,更是品牌事件营销</div>
              <div class="item-list">
                <div class="item">
                    <div class="icon-box">
                        <img src="../../assets/images/icon-contest-img.png"/>
                    </div>
                    <div class="item-desc">海量优秀作品生产</div>
                </div>
                <div class="item">
                    <div class="icon-box">
                        <img src="../../assets/images/icon-contest-flow.png"/>
                    </div>

                    <div class="item-desc">千万垂直流量聚合</div>
                </div>
                <div class="item">
                    <div class="icon-box">
                        <img src="../../assets/images/icon-contest-transmit.png"/>
                    </div>

                    <div class="item-desc">亿万品牌曝光传播</div>
                </div>
              </div>
        </div>
        <div class="community-contest">
			<div class="title-en">YICHUANG COMMUNITY</div>
			<div class="title-cn">衣创社区</div>
			<div class="content-box">
				<div class="item-box">
					<div class="item-num">40+<span>年</span></div>
					<div class="item-content">深耕服装行业</div>
				</div>
				<div class="item-box">
					<div class="item-num">1200<span>万</span></div>
					<div class="item-content">成衣年产量</div>
				</div>
				<div class="item-box">
					<div class="item-num">3500<span>吨</span></div>
					<div class="item-content">布匹年产量</div>
				</div>
			</div>
		</div>
		<div class="contest-about">
			<div class="about-content">
				<div class="title-en">ABOUT US</div>
				<div class="title-cn">关于我们<span class="line"></span></div>
				<div class="content-box">
				<div class="fifth-content">
					<div class="title">衣创社区背后的力量</div>
					<div class="content">
						历经40多年深耕服装行业，衣创社区的背后拥有雄厚的服装全产业链资源与成熟的「智能制造」体系。
						企业自建现代化标准厂房与智能化流水线，年均产量可达1200万套成衣、5000 吨布匹，实现从纺织、绣花到成衣等多环节的高度集成，
						并不断通过研发创新和质量管控提升生产稳定性与效率，凭借过硬的产品品质、丰富的行业经验以及广泛的国内外市场布局，先后斩获多项服装制造与科技创新领域的重要荣誉。
						业务版图遍及澳洲、美国、新西兰、柬埔寨等全球重点地区，拥有自有品牌、海外营销团队及完备的海外仓储物流体系，
						与众多知名企事业单位保持长期战略合作，持续扩大全球市场份额与品牌影响力。</div>
					<div class="title">衣创社区——行业首家AI赋能的一站式服装设计与生产、销售服务平台</div>
					<div class="content">
						正是在这强大产业基础之上应运而生，旨在为服装设计师们提供一站式的创意落地与商业化支持。
						从样衣制作到柔性供应链资源的有效对接，衣创社区致力于打造开放、共享、协同的生态平台，让更多设计灵感轻松转化为高品质成品。
						我们希望与每一位热爱设计、热爱服装创新的伙伴一道，引领服装行业的创意变革，为更多品牌与个人创造更广阔的价值舞台，为行业注入源源不断的活力与价值。</div>
					</div>
				</div>
			</div>
			<div class="bg"></div>
		</div>
        <SideMenu :is-work-weixin="true"></SideMenu>
    </div>
</template>
<script>
import { AddBannerStat, GetBannerList } from "@/api";
import { GetMatchList } from '@/api/social';
import SideMenu from '@/components/SideMenu/SideMenu';
import dayjs from 'dayjs';
import {
    swiper,
    swiperSlide
} from 'vue-awesome-swiper';
export default{
    data(){
        return {
            swiperOptions: {
                // 核心配置
                slidesPerView: 1,           // 每页显示 1 张幻灯片
                centeredSlides: true,       // 当前幻灯片居中显示
                spaceBetween: 10,           // 幻灯片间距
                loop: true,                 // 启用循环模式
                loopedSlides: 0,
                grabCursor: true,           // 拖动时显示抓手光标
                preventClicks:false,
                // preventClicksPropagation:false,
                autoplay: {
                    delay: 3000, // 3秒切换
                    disableOnInteraction: false // 手动滑动后继续自动播放
                },

                pagination: {
                    el: '.swiper-pagination', // 指定分页器容器选择器
                    type: 'bullets',          // 类型：bullets（圆点）、fraction（分数）、progress（进度条）等
                    clickable: true,          // 允许点击分页器切换幻灯片
                    bulletActiveClass: 'my-swiper-pagination-active', // 自定义激活状态类名
                },
                on: {
                    slideChange: this.onSlideChange, // 轮播图切换时的回调
                    init: this.onSwiperInit, // 轮播图初始化时的回调
                },
            },
            banner_list:[],
            list:[],
            isBackToTopVisible: false,
            page:1,
            limit:9,
            total_count:0,
			keyword: '', // 搜索关键词
            currentBannerIndex: 0, // 当前轮播图索引
            exposedBanners: new Set(), // 已曝光的banner ID集合

        }
    },
    components: {
        swiper,swiperSlide,SideMenu
    },
    filters:{
        countDay(val){
            const end_time = dayjs(val);
            const now = dayjs();
            const diffDays = end_time.diff(now, 'day');
            return diffDays >= 0 ? diffDays == 0 ? '距离截稿已不足24小时' :`距离截稿还剩${diffDays}天` : '已过截稿时间';
        },
        countSign(val){
            const end_time = dayjs(val);
            const now = dayjs();
            const diffDays = end_time.diff(now, 'day');
            return diffDays >= 0 ? diffDays == 0 ? '距报名截止已不足24小时' : `距离报名截止还剩${diffDays}天` : '已过报名时间';
        }
    },
    beforeRouteEnter(to, from, next) {
			next((vm) => {
			// 通过 `vm` 访问组件实例
			vm.$emit("changeFooter", 'light');
			});
		},
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
        this.$EventBus.$on('onHeaderSearch', (data) => {
            this.keyword = data?.keyword || '';
            this.onGetMatchList(); // 执行你的搜索方法
        });
        this.onGetBannerList();
        this.onGetMatchList();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        this.$EventBus.$off('onHeaderSearch');
    },
    methods:{
        // 轮播图初始化回调
        onSwiperInit() {
            // 初始化时记录第一张轮播图的曝光
            this.recordBannerExposure(0);
        },
        // 轮播图切换回调
        onSlideChange() {
            const swiper = this.$refs.mySwiper;
            if (swiper && swiper.swiper) {
                const activeIndex = swiper.swiper.realIndex; // 获取真实索引（考虑循环模式）
                this.currentBannerIndex = activeIndex;
                // 记录当前轮播图的曝光
                this.recordBannerExposure(activeIndex);
            }
        },
        // 记录轮播图曝光
        async recordBannerExposure(index) {
            try {
                const banner = this.banner_list[index];
                if (banner && banner.id) {
                    // 检查该banner是否已经统计过曝光
                    if (this.exposedBanners.has(banner.id)) {
                        return;
                    }
                    // 记录该banner已曝光
                    this.exposedBanners.add(banner.id);
                    // 调用接口统计曝光
                    await AddBannerStat({
                        banner_id: banner.id,
                        stat_type: 2, // 2表示曝光
                        user_id: this.$store.state.userInfo.id || 0
                    });
                }
            } catch (e) {
                console.log('曝光统计失败', e);
            }
        },
        // 记录轮播图点击
        async recordBannerClick(banner) {
            try {
                if (banner && banner.id) {
                    await AddBannerStat({
                        banner_id: banner.id,
                        stat_type: 1, // 1表示点击
                        user_id: this.$store.state.userInfo.id || 0
                    });
                }
            } catch (e) {
                console.log('点击统计失败', e);
            }
        },
        handleSwiperContainerClick(e) {
            // 查找最近带有 data-url 的图片元素
            const img = e.target.closest('.swiper-img');
            if (img) {
                const url = img.getAttribute('data-url');
                const index = this.currentBannerIndex;
                const banner = this.banner_list[index];
                // 记录点击统计
                this.recordBannerClick(banner);
                this.onSwiperClick({ url });
            }
        },
        onSwiperClick({ url }) {
            console.log("轮播点击", url);
            if (!url) return;
            if (url.startsWith("http")) {
                // window.location.href = url;
                window.open(url, "_blank");
            } else {
                this.$router.push(url);
            }
        },
        async onGetMatchList(){
            try{
                const {page,limit} = this;
                const param = {
                    page,
                    limit,
                    keyword: this.keyword || '',
                };
                const {data} = await GetMatchList(param);
                this.list = data.list;
                this.total_count = data.count;
            }catch(e){
                console.log('e',e);
            }
        },
        onPageChange(e){
            console.log('page_change',e);
            this.page = e;
            this.onGetMatchList();
        },
        handleScroll() {
            this.isBackToTopVisible = window.pageYOffset > 100; // 滚动超过 300px 显示
        },
        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },
        async onGetBannerList(){
            try{
                const param = {};
                param.position = 5;  // TODO 这里参数要改
                const {data} = await GetBannerList(param);
                this.swiperOptions.loopedSlides = data.length;
                this.banner_list = data;
            }catch(e){
                console.log('e-banner',e);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import './contest.scss'
</style>
